import styled, { css } from 'styled-components';
import { darkMode, darkPalette } from '../../core/theme/darkTheme';

interface ButtonProps {
  readonly $mt?: string | number;
  readonly $bottomMargin?: string | number;
  readonly $inverted?: boolean;
  readonly $customStyles?: {};
  readonly $withSecureLabels?: boolean;
}

export const StyledButton = styled.button<ButtonProps>`
  width: 100%;
  height: 48px;
  min-height: 48px;
  max-width: 406px;
  border-radius: 16px;
  background: ${({ $inverted, theme }) => ($inverted ? '#ffffff' : theme?.colors?.primary)};
  border: none;
  font-weight: 750;
  font-size: 14px;
  line-height: 17px;
  text-align: center;
  color: ${({ $inverted, theme }) => ($inverted ? theme?.colors?.primary : '#ffffff ')};
  transition: all 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: ${({ $mt }) => ($mt ? `${+$mt}${typeof $mt === 'number' ? 'px' : ''}` : '16px')};

  &:disabled {
    opacity: 0.5;

    &:hover {
      opacity: 0.5;
    }
  }

  &:focus {
    outline: none;
  }

  &:hover {
    opacity: 0.9;
    cursor: pointer;
  }
  ${({ $bottomMargin }) =>
    $bottomMargin &&
    css`
      max-width: 330px;
    `};
  ${({ $inverted }) =>
    darkMode(css`
      background: ${$inverted ? darkPalette.surface : darkPalette.accent};
      color: ${$inverted ? darkPalette.accent : darkPalette.onAccent};
    `)};
  ${({ $customStyles }) => $customStyles};

  @media screen and (max-width: ${({ theme }) => theme?.mobileWidth}px) {
    ${({ $bottomMargin }) =>
      $bottomMargin &&
      css`
        position: fixed;
        bottom: 24px;
        margin-top: 0;
        left: 50%;
        transform: translateX(-50%);
      `}
    ${({ $withSecureLabels }) =>
      $withSecureLabels &&
      css`
        position: static;
        left: unset;
        transform: unset;
      `}
  }
`;

export const ButtonWrapper = styled.div`
  position: fixed;
  width: 100%;
  max-width: 330px;
`;

export const TrustLabels = styled.div`
  display: flex;
  margin-top: 10px;
  gap: 10px;
  max-width: 285px;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
`;

export const TrustItem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ddefff;
  border-radius: 4px;
  gap: 6px;
  padding: 4px 8px;

  ${darkMode(css`
    background-color: ${darkPalette.accentSurface};
    border-radius: 8px;

    svg path {
      fill: ${darkPalette.accent};
    }
  `)}
`;

export const TrustText = styled.p`
  font-size: 10px;
  font-weight: 700;
  color: #1f7ace;

  ${darkMode(css`
    color: ${darkPalette.accent};
  `)}
`;
